import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		xmlns: "http://www.w3.org/2000/svg",
		d: "m17.642 16.093 6.22-6.22c.43-.43.43-1.13 0-1.55-.43-.43-1.13-.43-1.55 0l-6.22 6.22-6.22-6.22c-.43-.43-1.13-.43-1.55 0-.43.43-.43 1.13 0 1.55l6.22 6.22-6.22 6.22c-.43.43-.43 1.13 0 1.55.21.21.5.32.78.32s.56-.11.78-.32l6.22-6.22 6.22 6.22c.21.21.5.32.78.32s.56-.11.78-.32c.43-.43.43-1.13 0-1.55l-6.22-6.22h-.02Z"
	})
});
export { SvgClose as ReactComponent };
